export const PERMISSIONS = {
  locales: {
    read: 'locales:read',
    modify: 'locales:modify',
  },
};
